<div class="modal-header">
    <h5 class="modal-title">Aylık Rapor Seçimi</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row mb-50">
        <div class="col-xl-1 col-md-6 col-sm-12">
            <label for="year">Yıl</label>
            <select id="year" class="form-control" [(ngModel)]="selectedYear">
                <option *ngFor="let y of years" [value]="y">{{ y }}</option>
            </select>
        </div>
        <div class="col-xl-1 col-md-6 col-sm-12">
            <label for="month">Ay</label>
            <select id="month" class="form-control" [(ngModel)]="selectedMonth">
                <option *ngFor="let m of months" [value]="m.value">{{ m.name }}</option>
            </select>
        </div>
        <div class="col-xl-3 col-md-6 col-sm-12">
            <label for="search">Ara</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon-search1"><i data-feather="search"></i></span>
                </div>
                <input type="search" placeholder="Depertamana göre bul veya isme göre ara" class="form-control"
                    (keyup)="filterUpdate($event)" aria-describedby="basic-addon-search1"
                    (search)="filterUpdate($event)" />
            </div>
        </div>
        <div class="col-xl-2 mt-2">
            <button *ngIf="datas.length > 0" class="btn btn-success" (click)="exportAsExcel()">
                Excel'e Aktar
            </button>
        </div>

        <div class="col-xl-5 d-flex justify-content-end">
            <button type="button" rippleEffect class="btn btn-sm btn-outline-primary mt-2" placement="bottom"
                [ngbTooltip]="legendTooltip" tooltipClass="legend-tooltip" style="max-height: 35px;">
                <span data-feather="eye"></span>
            </button>

            <ng-template #legendTooltip>
                <div class="legend-tooltip-content">
                    <div *ngFor="let item of legendData" class="legend-item">
                        <strong>{{ item.kod }}</strong>: {{ item.tanim }}
                    </div>
                </div>
            </ng-template>
        </div>

    </div>
    <div *ngIf="datas.length > 0">

        <!-- data == true => İzin ve Mesai Saatleri Tablosu -->
        <div *ngIf="data == true" class="table-responsive">
            <table class="table table-sm table-bordered table-striped">
                <thead class="table-light" style="height: 50px;">
                    <tr>
                        <th>Sicil No</th>
                        <th>Ad Soyad</th>
                        <th>Departman</th>
                        <th>Yıllık İzin (Gün)</th>
                        <th>Ücretsiz İzin (Gün)</th>
                        <th>Rapor (Gün)</th>
                        <th>Evlilik İzni (Gün)</th>
                        <th>Doğum İzni (Gün)</th>
                        <th>Cenaze İzni (Gün)</th>
                        <th>İdari İzin (Gün)</th>
                        <th>Hafta İçi Mesai (saat)</th>
                        <th>Hafta Sonu Mesai (saat)</th>
                        <th>Uzaktan Mesai (saat)</th>
                        <th>Telafi Çalışması (saat)</th>
                        <th>Destek Çalışması (saat)</th>
                        <th>Resmi Tatil Mesaisi (saat)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let person of datas">
                        <td>{{ person.registrationNumber }}</td>
                        <td class="truncate-text" title="{{ person.fullName }}">
                            {{ person.fullName }}
                        </td>
                        <td class="truncate-text" title="{{ person.department }}">{{ person.department }}</td>
                        <td>{{ person.annualLeave }}</td>
                        <td>{{ person.unpaidLeave }}</td>
                        <td>{{ person.reportLeave }}</td>
                        <td>{{ person.marriageLeave }}</td>
                        <td>{{ person.maternityLeave }}</td>
                        <td>{{ person.funeralLeave }}</td>
                        <td>{{ person.administrativeLeave }}</td>
                        <td>{{ person.weekdayOvertime }}</td>
                        <td>{{ person.weekendOvertime }}</td>
                        <td>{{ person.remoteWork }}</td>
                        <td>{{ person.compensationWork }}</td>
                        <td>{{ person.supportWork }}</td>
                        <td>{{ person.officialHoliday }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="data == false" class="table-responsive">
            <table class="table table-sm table-bordered table-striped">
                <thead class="table-light" style="height: 50px;">
                    <tr>
                        <th>Sicil No</th>
                        <th>Ad Soyad</th>
                        <th>Departman</th>
                        <th>Yıl. İzin</th>
                        <th>Rapor</th>
                        <th>Diğer</th>
                        <th>Ç. Günü</th>
                        <th *ngFor="let day of [].constructor(31); let i = index"> {{ i + 1 }} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let person of datas">
                        <td style="white-space: nowrap;">{{ person.registrationNumber }}</td>
                        <td class="truncate-text" title="{{ person.fullName }}">
                            {{ person.fullName }}
                        </td>
                        <td class="truncate-text" title="{{ person.depertmant }}">{{ person.depertmant }}</td>
                        <td style="text-align: center;">{{ person.annualLeave }}</td>
                        <td style="text-align: center;">{{ person.report }}</td>
                        <td style="text-align: center;"> {{ person.other == 0 ? '' : (person.other % 1 === 0 ?
                            person.other : (person.other | number:'1.1-1')) }}
                        </td>
                        <td style="text-align: center;">{{ person.onlyXDays }}</td>
                        <td *ngFor="let day of [].constructor(31); let i = index">
                            {{ person.days[i + 1] || '-' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="submit()" [disabled]="isLoading">
        {{ isLoading ? 'Yükleniyor...' : 'Görüntüle' }}
    </button>
    <button class="btn btn-outline-secondary" (click)="close()">İptal</button>
</div>